import React, { useEffect, useState } from "react";
import { Skeleton } from "antd";
import { generalErrorAlert } from "../../../commons/GeneralErrorAlert";
import { getMeta } from "./api";
import ProjectDiary from "./ProjectDiary";
import "./siteDiary.css";

/** The site diary tab of a project's page. Hidden when the server refuses access. */
const SiteDiaryPanel = ({ project, clientEmail }) => {
  const [can, setCan] = useState(null);
  const [denied, setDenied] = useState(false);

  useEffect(() => {
    let cancelled = false;
    getMeta()
      .then(res => !cancelled && setCan(res.data.can))
      .catch(error => {
        if (cancelled) return;
        if (error?.response?.status === 403) setDenied(true);
        else generalErrorAlert(error);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (denied) return null;
  if (!can) return <Skeleton active paragraph={{ rows: 3 }} />;
  return (
    <div className="site-diary-page sdi-panel">
      <ProjectDiary project={project} can={can} clientEmail={clientEmail} />
    </div>
  );
};

export default SiteDiaryPanel;
